/**
 * Filter positive values
 * @param  {Number} value The value to Filter
 * @return {Boolean} true if value is positive, false otherwise
 */
export default function (value) {
  return value > 0;
}
